<template>
<div class="col-12 text-left">
    <app-nav-bar></app-nav-bar>
    <div class="main-content">
        <h3 class="p-2">
            <small class="text-muted">Expense Form Detail</small>
        </h3>
        <div class="p-2 dropdown-divider"></div>
        <div class="row">
            <div class="form-group col-3">
                <label>Expense Form No</label>
                <input type="text" class="form-control" disabled v-model="expenseForm.expensesFormNo" id="expensesFormNo" aria-describedby="expensesFormNo">
            </div>
             <div class="form-group col-3">
                <label for="date">Date</label>
                <flat-pickr class="form-control" id="expense-date" v-model="expenseForm.expensesDate"></flat-pickr>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-3">
                <label for="module">Expense</label>
                <app-lookup-field :model="expenseForm" :element="expenseLookup" v-on:selectLookup="finishLookup"></app-lookup-field>
            </div>
            <div v-if="expenseForm.expensesCategory === 'salary'" class="form-group col-3">
                <label>Category Remark</label>
                <input type="text" class="form-control" v-model="expenseForm.categoryRemarks" id="price" aria-describedby="categoryRemark">
            </div>
            <div class="form-group col-6">
                <label for="module">Remarks</label>
                <textarea class="form-control" id="desc-textarea" v-model="expenseForm.expenseRemarks" disabled rows="2"></textarea>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-3">
                <label for="module">Supplier Name</label>
                <app-lookup-field :model="expenseForm" :element="supplierLookup" v-on:selectLookup="finishLookup"></app-lookup-field>
            </div>
            <div class="form-group col-3">
                <label for="module">UOM Name</label>
                <app-lookup-field :model="expenseForm" :element="uomLookup" v-on:selectLookup="finishLookup"></app-lookup-field>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-3">
                <label>Price</label>
                <input type="number" class="form-control" v-model="expenseForm.price" id="price" aria-describedby="price">
            </div>
        </div>
        <div class="row">
            <div class="form-group col-6">
                <label for="module">Remarks</label>
                <textarea class="form-control" id="desc-textarea" v-model="expenseForm.remarks" rows="2"></textarea>
            </div>
        </div>
        <button type="button" class="btn btn-outline-success" @click="save">Save <i class="far fa-save"></i></button>
        <button type="button" class="btn btn-outline-danger" @click="cancel" style="margin-left: 20px;">Cancel <i class="far fa-window-close"></i></button>
        <br /><br />
    </div>
</div>
</template>

<script>
import api from '../../services/api'
import { ExpenseForm } from '../../models/expenseForm'
import AppLookupField from '../../components/AppLookupField.vue'
import AppDatatable from '../../components/AppDatatable.vue'
import AppDatePicker from '../../components/AppDatePicker.vue'
import AppDropdown from '../../components/AppDropdown.vue'
import AppNavBar from '../../components/AppNavbar.vue'

export default {
    components: {
        AppLookupField, AppDatatable, AppDatePicker, AppDropdown, AppNavBar
    },
    data() {
        return {
            expenseForm: {
                ...ExpenseForm
            },
            expenseLookup: {
                id: 'expense',
                title: 'Expense List',
                type: 'form',
                apiUrl: 'expense-list',
                filter: ['name'],
                fields: [
                    {
                        placeholder: 'Expense',
                        width: 12,
                        column: 'expensesName'
                    }
                ],
                dtElements: [
                    {
                        title: 'Expense Name',
                        column: 'name'
                    },
                    {
                        title: 'Expense Category',
                        column: 'category'
                    },
                    {
                        title: 'Expense Remarks',
                        column: 'remarks'
                    },
                ],
                affectedField: [
                    {
                        from: 'id',
                        to: 'expensesId'
                    },
                    {
                        from: 'name',
                        to: 'expensesName'
                    },
                    {
                        from: 'category',
                        to: 'expensesCategory'
                    },
                    {
                        from: 'remarks',
                        to: 'expenseRemarks'
                    }
                ]
            },
            supplierLookup: {
                id: 'supplier-list',
                title: 'Supplier List',
                type: 'form',
                apiUrl: 'supplier-list',
                filter: ['name'],
                fields: [
                    {
                        placeholder: 'Supplier Name',
                        width: 12,
                        column: 'supplierName'
                    }
                ],
                dtElements: [
                    {
                        title: 'Supplier Name',
                        column: 'name'
                    },
                ],
                affectedField: [
                    {
                        from: 'id',
                        to: 'supplierId'
                    },
                    {
                        from: 'name',
                        to: 'supplierName'
                    },
                ]
            },
            uomLookup: {
                id: 'uom-list',
                title: 'UOM List',
                type: 'form',
                apiUrl: 'uom-list',
                filter: ['name'],
                fields: [
                    {
                        placeholder: 'UOM Name',
                        width: 12,
                        column: 'uomName'
                    }
                ],
                dtElements: [
                    {
                        title: 'UOM Name',
                        column: 'name'
                    },
                ],
                affectedField: [
                    {
                        from: 'id',
                        to: 'uomId'
                    },
                    {
                        from: 'name',
                        to: 'uomName'
                    },
                ]
            },
        }
    },
    async created() {
        if(this.$route.query.id !== undefined) {
            const efApi = api('expense-form/detail')

            const efResult = await efApi.getWithParams(this.$route.query.id)
            this.expenseForm = efResult
        }
    },
    methods: {
        async save() {
            const efApi = api('expense-form')
            if(this.$route.query.id !== undefined) {
                await efApi.update(this.expenseForm, this.$route.query.id)
            } else {
                await efApi.create(this.expenseForm)
            }
            this.$router.push({ name: 'expenseForm' })
        },
        cancel() {
            this.$router.push({ name: 'expenseForm' })
        },
        finishLookup(data) {
            const currentExpenseForm = this.expenseForm
            this.expenseForm = {
                ...currentExpenseForm,
                ...data
            }
        },
        selectChange(data) {
            const currentExpenseForm = this.expenseForm
            this.expenseForm = {
                ...currentExpenseForm,
                ...data
            }
        },
    }
}
</script>